module.exports = __webpack_public_path__ + "img/Dolen_Bilde-av-Rondane.a80e0af5.jpg";